module.exports = "<div id=\"loader\" [hidden]=\"status != 'loading'\">\n  <itpx-spinner></itpx-spinner>\n</div>\n\n<iframe *ngIf=\"deliverable\" [src]=\"url\" allowfullscreen>\n</iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/google-slides/google-slides.component.html
// module id = 878
// module chunks = 0